import { render } from "./Test2.vue?vue&type=template&id=0cbe941e"
import script from "./Test2.vue?vue&type=script&lang=js"
export * from "./Test2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__